"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageHandler = void 0;
var LocalStorageHandler = /** @class */ (function () {
    function LocalStorageHandler() {
        this.localStorage = window.localStorage;
    }
    /**
     * // Pass a key name to get its value.
     * @param key
     */
    LocalStorageHandler.prototype.getItem = function (key) {
        var item = this.localStorage.getItem(key);
        if (item != null) {
            item = JSON.parse(item);
        }
        return item;
    };
    /**
     * Pass a key name and its value to add or update that key.
     * @param key
     * @param value
     */
    LocalStorageHandler.prototype.saveItem = function (key, value) {
        this.localStorage.setItem(key, JSON.stringify(value));
    };
    /**
     * Pass a key name to remove that key from storage.
     * @param key
     */
    LocalStorageHandler.prototype.removeItem = function (key) {
        this.localStorage.removeItem(key);
    };
    return LocalStorageHandler;
}());
exports.LocalStorageHandler = LocalStorageHandler;
